import { render, staticRenderFns } from "./MySubscriptions.vue?vue&type=template&id=04779f67&scoped=true"
import script from "./MySubscriptions.vue?vue&type=script&lang=js"
export * from "./MySubscriptions.vue?vue&type=script&lang=js"
import style0 from "./MySubscriptions.vue?vue&type=style&index=0&id=04779f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04779f67",
  null
  
)

export default component.exports